// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
    display: inline;
}
input, .password-input {
    display: inline;
    width: 100%;
    /*font-family: Courier;*/
    font: inherit;
	border: 1px solid #a0a0a0;
	border-radius: 3px;
	margin: 3px;
}

.error {
    color: red;
}
.success {
    color: green;
}
.form-group {
    margin-bottom: 1rem;
}
input[type="submit"], input[type="button"] {
    margin-bottom: 2rem;
}

button,
input[type="button"],
input[type="reset"],
input[type="submit"] {
	border: 1px solid;
	border-radius: 0px;
	background-color: var(--first-color);/*#e6e6e6;*/
	color: white; /*rgba(0, 0, 0, 0.8);*/
	/*font-variant: small-caps;*/
	line-height: 1;
	padding: 10px 20px;
    font-size: 1em;
    font-weight: 400;
    width: fit-content;
	cursor: pointer;
}

button:disabled,
input[type="button"]:disabled,
input[type="reset"]:disabled,
input[type="submit"]:disabled {
	cursor: not-allowed !important;
	pointer-events: none !important;
	opacity: 0.6;
}

button:hover,
input[type="button"]:hover,
input[type="reset"]:hover,
input[type="submit"]:hover {
	border-color: #ccc #bbb #aaa;
	transform: scale(1.05);
}

button:active,
button:focus,
input[type="button"]:active,
input[type="button"]:focus,
input[type="reset"]:active,
input[type="reset"]:focus,
input[type="submit"]:active,
input[type="submit"]:focus {
	border-color: #aaa #bbb #bbb;
}

input[type='checkbox'] {
	font-size: 200px;
	margin: 5px;
	width: auto;
}
input[type="text"],
input[type="email"],
input[type="url"],
input[type="password"],
input[type="search"],
input[type="number"],
input[type="tel"],
input[type="range"],
input[type="date"],
input[type="month"],
input[type="week"],
input[type="time"],
input[type="datetime"],
input[type="datetime-local"],
input[type="color"],
textarea {
	color: #666;
	border: 1px solid #ccc;
	border-radius: 3px;
	padding: 3px;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="url"]:focus,
input[type="password"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="tel"]:focus,
input[type="range"]:focus,
input[type="date"]:focus,
input[type="month"]:focus,
input[type="week"]:focus,
input[type="time"]:focus,
input[type="datetime"]:focus,
input[type="datetime-local"]:focus,
input[type="color"]:focus,
textarea:focus {
	color: #111;
}
select {
	border: 1px solid #ccc;
    /*font-family: Courier;*/
    font-size: 1em;
    color: black;
}
textarea {
	width: 100%;
}
form label {
    display: inline;
    /*margin: 5px 0px 30px 0px;*/
    /*font-family: Courier;*/
    font-size: 1em;
}

form div.form-row {
    margin-bottom: 1.25rem;
    display: flex;
}
form div.form-row * {
    width: auto;
    margin: 0px 20px 0px 0px;
}
form div.form-row input[type=number] {
    width: 60px;
    padding: 5px;
}
form span {
    /*font-family: Courier;*/
    font-size: 1em;
    color: black;
}
form option {
    /*font-family: Courier;*/
    font-size: 1em;
}

.wp-block-column {
    padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/BookingApp.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,WAAW;IACX,wBAAwB;IACxB,aAAa;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;IACI,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;;;;CAIC,iBAAiB;CACjB,kBAAkB;CAClB,oCAAoC,CAAC,WAAW;CAChD,YAAY,EAAE,sBAAsB;CACpC,4BAA4B;CAC5B,cAAc;CACd,kBAAkB;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;CACrB,eAAe;AAChB;;AAEA;;;;CAIC,8BAA8B;CAC9B,+BAA+B;CAC/B,YAAY;AACb;;AAEA;;;;CAIC,4BAA4B;CAC5B,sBAAsB;AACvB;;AAEA;;;;;;;;CAQC,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,WAAW;AACZ;AACA;;;;;;;;;;;;;;;;CAgBC,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;AACb;;AAEA;;;;;;;;;;;;;;;;CAgBC,WAAW;AACZ;AACA;CACC,sBAAsB;IACnB,wBAAwB;IACxB,cAAc;IACd,YAAY;AAChB;AACA;CACC,WAAW;AACZ;AACA;IACI,eAAe;IACf,4BAA4B;IAC5B,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,WAAW;IACX,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,cAAc;IACd,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["form {\n    display: inline;\n}\ninput, .password-input {\n    display: inline;\n    width: 100%;\n    /*font-family: Courier;*/\n    font: inherit;\n\tborder: 1px solid #a0a0a0;\n\tborder-radius: 3px;\n\tmargin: 3px;\n}\n\n.error {\n    color: red;\n}\n.success {\n    color: green;\n}\n.form-group {\n    margin-bottom: 1rem;\n}\ninput[type=\"submit\"], input[type=\"button\"] {\n    margin-bottom: 2rem;\n}\n\nbutton,\ninput[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n\tborder: 1px solid;\n\tborder-radius: 0px;\n\tbackground-color: var(--first-color);/*#e6e6e6;*/\n\tcolor: white; /*rgba(0, 0, 0, 0.8);*/\n\t/*font-variant: small-caps;*/\n\tline-height: 1;\n\tpadding: 10px 20px;\n    font-size: 1em;\n    font-weight: 400;\n    width: fit-content;\n\tcursor: pointer;\n}\n\nbutton:disabled,\ninput[type=\"button\"]:disabled,\ninput[type=\"reset\"]:disabled,\ninput[type=\"submit\"]:disabled {\n\tcursor: not-allowed !important;\n\tpointer-events: none !important;\n\topacity: 0.6;\n}\n\nbutton:hover,\ninput[type=\"button\"]:hover,\ninput[type=\"reset\"]:hover,\ninput[type=\"submit\"]:hover {\n\tborder-color: #ccc #bbb #aaa;\n\ttransform: scale(1.05);\n}\n\nbutton:active,\nbutton:focus,\ninput[type=\"button\"]:active,\ninput[type=\"button\"]:focus,\ninput[type=\"reset\"]:active,\ninput[type=\"reset\"]:focus,\ninput[type=\"submit\"]:active,\ninput[type=\"submit\"]:focus {\n\tborder-color: #aaa #bbb #bbb;\n}\n\ninput[type='checkbox'] {\n\tfont-size: 200px;\n\tmargin: 5px;\n\twidth: auto;\n}\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"url\"],\ninput[type=\"password\"],\ninput[type=\"search\"],\ninput[type=\"number\"],\ninput[type=\"tel\"],\ninput[type=\"range\"],\ninput[type=\"date\"],\ninput[type=\"month\"],\ninput[type=\"week\"],\ninput[type=\"time\"],\ninput[type=\"datetime\"],\ninput[type=\"datetime-local\"],\ninput[type=\"color\"],\ntextarea {\n\tcolor: #666;\n\tborder: 1px solid #ccc;\n\tborder-radius: 3px;\n\tpadding: 3px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"email\"]:focus,\ninput[type=\"url\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"search\"]:focus,\ninput[type=\"number\"]:focus,\ninput[type=\"tel\"]:focus,\ninput[type=\"range\"]:focus,\ninput[type=\"date\"]:focus,\ninput[type=\"month\"]:focus,\ninput[type=\"week\"]:focus,\ninput[type=\"time\"]:focus,\ninput[type=\"datetime\"]:focus,\ninput[type=\"datetime-local\"]:focus,\ninput[type=\"color\"]:focus,\ntextarea:focus {\n\tcolor: #111;\n}\nselect {\n\tborder: 1px solid #ccc;\n    /*font-family: Courier;*/\n    font-size: 1em;\n    color: black;\n}\ntextarea {\n\twidth: 100%;\n}\nform label {\n    display: inline;\n    /*margin: 5px 0px 30px 0px;*/\n    /*font-family: Courier;*/\n    font-size: 1em;\n}\n\nform div.form-row {\n    margin-bottom: 1.25rem;\n    display: flex;\n}\nform div.form-row * {\n    width: auto;\n    margin: 0px 20px 0px 0px;\n}\nform div.form-row input[type=number] {\n    width: 60px;\n    padding: 5px;\n}\nform span {\n    /*font-family: Courier;*/\n    font-size: 1em;\n    color: black;\n}\nform option {\n    /*font-family: Courier;*/\n    font-size: 1em;\n}\n\n.wp-block-column {\n    padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
